/**
 * @file Component to view the number of calls
 * @author Heino Lenting, Maarten Lensink
 */
import { SettingsService } from '../settings.service';
var PluginPairService = /** @class */ (function () {
    /**
     * Creates an instance of PluginPairService
     * @param {SettingsService} settingsService The settings service
     * @memberOf PluginPairService
     */
    function PluginPairService(settingsService) {
        // List of plugins (Add 'PLUGIN_CAPACITY' etc to make the Capacity plugin visible)
        this.normalPluginPairs = [
            {
                name: 'PLUGIN_EMPTY',
                title: 'APP.PLUGINS.PLUGIN_EMPTY',
                filterMethod: 'none',
                views: ['sym-plugin-view-empty']
            },
            {
                name: 'PLUGIN_SHIFTS',
                title: 'APP.PLUGINS.PLUGIN_SHIFTS',
                filterMethod: 'function',
                views: ['sym-plugin-view-empty', 'sym-plugin-view-attendants']
            }
        ];
        this.scriptingPluginPairs = [
            {
                name: 'PLUGIN_EMPTY',
                title: 'APP.PLUGINS.PLUGIN_EMPTY',
                filterMethod: 'none',
                views: ['sym-plugin-view-empty']
            },
            {
                name: 'PLUGIN_CONTROLS',
                title: 'APP.PLUGINS.PLUGIN_CONTROLS',
                filterMethod: 'function',
                views: ['sym-plugin-view-empty', 'sym-plugin-view-forecast-controls']
            },
            {
                name: 'PLUGIN_SHIFTS',
                title: 'APP.PLUGINS.PLUGIN_SHIFTS',
                filterMethod: 'function',
                views: ['sym-plugin-view-empty', 'sym-plugin-view-attendants']
            }
        ];
        // List of plugins (Add 'PLUGIN_CAPACITY' etc to make the Capacity plugin visible)
        this.forecastPluginPairs = [
            {
                name: 'PLUGINS_PAIR_EMPTY',
                title: 'APP.PLUGINS.PLUGINS_PAIR_EMPTY',
                filterMethod: 'none',
                views: ['sym-plugin-view-empty']
            },
            {
                name: 'PLUGINS_PAIR_PROGNOSES_CONTROLS',
                title: 'APP.PLUGINS.PLUGINS_PAIR_PROGNOSES_CONTROLS',
                filterMethod: 'function',
                views: ['sym-plugin-view-prognoses', 'sym-plugin-view-forecast-controls']
            },
            {
                name: 'PLUGINS_PAIR_PROGNOSES_CORRECTIONS',
                title: 'APP.PLUGINS.PLUGINS_PAIR_PROGNOSES_CORRECTIONS',
                filterMethod: 'function',
                views: ['sym-plugin-view-prognoses', 'sym-plugin-view-corrections']
            },
            {
                name: 'PLUGINS_PAIR_PROGNOSES_CALLS',
                title: 'APP.PLUGINS.PLUGINS_PAIR_PROGNOSES_CALLS',
                filterMethod: 'function',
                views: ['sym-plugin-view-prognoses', 'sym-plugin-view-calls']
            },
            {
                name: 'PLUGINS_PAIR_CAPACITY_SHRINKAGE',
                title: 'APP.PLUGINS.PLUGINS_PAIR_CAPACITY_SHRINKAGE',
                filterMethod: 'function',
                views: ['sym-plugin-view-capacity', 'sym-plugin-view-shrinkage']
            },
            {
                name: 'PLUGINS_PAIR_CHECK_SCRIPT',
                title: 'APP.PLUGINS.PLUGINS_PAIR_CHECK_SCRIPT',
                filterMethod: 'function',
                views: ['sym-plugin-view-service-level', 'sym-plugin-view-generated']
            },
            {
                name: 'PLUGINS_PAIR_SLA_FORECAST',
                title: 'APP.PLUGINS.PLUGINS_PAIR_SLA_FORECAST',
                filterMethod: 'function',
                views: ['sym-plugin-view-service-level', 'sym-plugin-view-attendants']
            },
            {
                name: 'PLUGINS_PAIR_CAPACITY_FORECAST',
                title: 'APP.PLUGINS.PLUGINS_PAIR_CAPACITY_FORECAST',
                filterMethod: 'function',
                views: ['sym-plugin-view-capacity', 'sym-plugin-view-attendants']
            },
            {
                name: 'PLUGIN_SHIFTS',
                title: 'APP.PLUGINS.PLUGIN_SHIFTS',
                filterMethod: 'function',
                views: ['sym-plugin-view-empty', 'sym-plugin-view-attendants']
            }
        ];
        if (settingsService.settings.forecast) {
            this.pluginPairs = this.forecastPluginPairs;
        }
        else if (settingsService.settings.autoplan) {
            this.pluginPairs = this.scriptingPluginPairs;
        }
        else {
            this.pluginPairs = this.normalPluginPairs;
        }
    }
    Object.defineProperty(PluginPairService.prototype, "selectedPluginPair", {
        /**
         * Get the selected plugins pair
         * @readonly
         * @type {PluginPair}
         * @memberOf PluginPairService
         */
        get: function () {
            if (this._pluginPair) {
                return this._pluginPair;
            }
            return this.pluginPairs[0];
        },
        /**
         * Sets the selected plugins pair
         * @memberOf PluginPairService
         */
        set: function (pluginPair) {
            if (this.pluginPairs.indexOf(pluginPair) > -1) {
                this._pluginPair = pluginPair;
            }
            else {
                this.clearSelected();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
    * Clear the selection
     * @memberOf PluginPairService
    */
    PluginPairService.prototype.clearSelected = function () {
        this._pluginPair = undefined;
        this.selectedFunction = undefined;
    };
    return PluginPairService;
}());
export { PluginPairService };
